module.exports = __webpack_public_path__ + "paymentProcess.5c4fcc78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/weChatPosterPayment/images/paymentProcess.jpg
// module id = qWZl
// module chunks = 0